import axios from 'axios'

const API_URL = process.env.VUE_APP_API_HOST_DOMAIN
const headers = {
    'Content-Type': 'application/json; charset=utf-8'
}
const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}

function isFormData(data) {
    return typeof FormData !== 'undefined' && data instanceof FormData
}

export default {
    post(urlPath, data) {
        return this.request(urlPath, 'POST', isFormData(data) ? formDataHeaders : headers, data)
    },
    put(urlPath, data) {
        return this.request(urlPath, 'PUT', isFormData(data) ? formDataHeaders : headers, data)
    },
    get(urlPath) {
        return this.request(urlPath, 'GET', headers, null)
    },
    delete(urlPath) {
        return this.request(urlPath, 'DELETE', headers, null)
    },
    getFile(urlPath) {
        window.open(API_URL + urlPath, '_blank')
    },
    uploadFile(urlPath, formData) {
        return this.request(urlPath, 'POST', formDataHeaders, formData)
    },
    request(urlPath, method, headers, data) {
        method = method || 'POST'
        data = data || {}
        headers = { ...headers }

        if (isFormData(data)) {
            delete headers['Content-Type']
        }

        const apiToken = localStorage.getItem('api-token')
        if (apiToken) {
            headers = {
                ...headers,
                'Authorization': 'Bearer ' + apiToken
            }
        }

        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + '/' + urlPath,
                data: data,
                method: method,
                headers: headers
            }).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error)
            })
        })
    }
}
